export const loginRequestScopes = ["openid"];
